// extracted by mini-css-extract-plugin
export var chevronIcon = "_4y-2";
export var teamName = "_4y-1";
export var teamSwitcherButton = "_4y-0";